import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';

function CustomPagination({ data, setFilters, filters }: any) {
    const [page, setPage] = React.useState<number>(0);

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        const offset = filters?.offset;
        const limit = filters?.limit;
        setFilters({
            ...filters,
            offset: newPage > page ? offset + limit : offset - limit
        });
        setPage(newPage);
    };

    React.useEffect(() => {
        if (filters?.offset === 0) setPage(0);
        else setPage(filters?.offset / filters?.limit);
    }, [filters]);

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setFilters({
            ...filters,
            offset: 0,
            limit: event?.target?.value
        });
        setPage(0);
    };

    return (
        <TablePagination
            component="div"
            count={data?.info?.total || 0}
            page={page || 0}
            rowsPerPageOptions={[5, 10, 20, 50]}
            onPageChange={handleChangePage}
            rowsPerPage={filters?.limit || 10}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={<span>Items por página: </span>}
            labelDisplayedRows={({ from, to, count }: any) => {
                return `${from}–${to} de ${count !== -1 ? count : `más de ${to}`} items`;
            }}
        />
    );
}

export default CustomPagination;
